export const adjustmentHeaderFields = [
    { name: "Warehouse", label: "Warehouse" },
    { name: "ItrnKey", label: "ITRN Key" },
    { name: "TranType", label: "Tran Type" },
    { name: "Adjustmentkey", label: "Adjustment Key" },
    { name: "StorerKey", label: "Storer Key" },
    { name: "ReferenceNumber", label: "Reference Number" },
    { name: "AdjustmentAddDate", label: "Adjustment Add Date" },
    { name: "Notes", label: "Notes" },
    { name: "SourceType", label: "Source Type" },
    { name: "SourceKey", label: "Source Key" },
    { name: "addwho", label: "Added By" },
    { name: "editwho", label: "Edited By" },
    { name: "editdate", label: "Edit Date", type: "text", readOnly: true },
];

export const adjustmentDetailColumns = [
    { field: "lineNo", headerName: "Line#", width: 70, sortable: false },
    { field: "Adjustmentlinenumber", headerName: "Adj Line No", width: 120, sortable: false },
    { field: "Sku", headerName: "SKU", width: 130, sortable: false },
    { field: "Description", headerName: "Description", width: 220, sortable: false },
    { field: "Location", headerName: "Location", width: 120, sortable: false },
    { field: "Lot", headerName: "Lot", width: 130, sortable: false },
    { field: "LPN", headerName: "LPN", width: 130, sortable: false },
    { field: "Quantity", headerName: "Quantity", width: 100, sortable: false },
    { field: "ReasonCode", headerName: "Reason Code", width: 130, sortable: false },
    { field: "PackKey", headerName: "Pack Key", width: 110, sortable: false },
    { field: "UOM", headerName: "UOM", width: 80, sortable: false },
    { field: "Notes", headerName: "Notes", width: 200, sortable: false },
    { field: "Status", headerName: "Status", width: 100, sortable: false },
    { field: "NetWeight", headerName: "Net Weight", width: 110, sortable: false },
    { field: "Lottable01", headerName: "Lottable01", width: 120, sortable: false },
    { field: "Lottable02", headerName: "Lottable02", width: 120, sortable: false },
    { field: "Lottable09", headerName: "Lottable09", width: 120, sortable: false },
    { field: "Lottable10", headerName: "Lottable10", width: 120, sortable: false },
    { field: "CountSequence", headerName: "Count Sequence", width: 140, sortable: false },
];
